module.exports = __webpack_public_path__ + "img/addChartWhite.7e466449.svg";